import Vue from 'vue'
import workflowHelper from '../workflow.helper'
import fileslotsHelper from '../fileslot.helper'

Vue.prototype.$workflow = workflowHelper
Vue.prototype.$fileslot = fileslotsHelper

Vue.prototype.$compare = {
  'obj': function (x, y) {
    'use strict'

    if (x === null || x === undefined || y === null || y === undefined) { return x === y }
    // after this just checking type of one would be enough
    if (x.constructor !== y.constructor) { return false }
    // if they are functions, they should exactly refer to same one (because of closures)
    if (x instanceof Function) { return x === y }
    // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
    if (x instanceof RegExp) { return x === y }
    if (x === y || x.valueOf() === y.valueOf()) { return true }
    if (Array.isArray(x) && x.length !== y.length) { return false }

    // if they are dates, they must had equal valueOf
    if (x instanceof Date) { return false }

    // if they are strictly equal, they both need to be object at least
    if (!(x instanceof Object)) { return false }
    if (!(y instanceof Object)) { return false }

    // recursive object equality check
    var p = Object.keys(x)
    return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1 }) &&
      p.every(function (i) { return Vue.prototype.$compare.obj(x[i], y[i]) })
  }
}

Array.prototype.rotate = (function () {
  let unshift = Array.prototype.unshift
  let splice = Array.prototype.splice

  return function (count) {
    let len = this.length >>> 0
    let count1 = count >> 0

    unshift.apply(this, splice.call(this, count1 % len, len))
    return this
  }
})()
